var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 56.25H30C28.9646 56.25 28.125 55.4104 28.125 54.375V5.625C28.125 4.58962 28.9646 3.75 30 3.75H52.5C53.5354 3.75 54.375 4.58962 54.375 5.625V54.375C54.375 55.4104 53.5354 56.25 52.5 56.25ZM31.875 52.5H50.625V7.5H31.875V52.5Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56.25H37.5C36.4646 56.25 35.625 55.4104 35.625 54.375V43.125C35.625 42.0896 36.4646 41.25 37.5 41.25H45C46.0354 41.25 46.875 42.0896 46.875 43.125V54.375C46.875 55.4104 46.0354 56.25 45 56.25ZM39.375 52.5H43.125V45H39.375V52.5Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.25H7.5C6.46462 56.25 5.625 55.4104 5.625 54.375V24.375C5.625 23.3396 6.46462 22.5 7.5 22.5H30C31.0354 22.5 31.875 23.3396 31.875 24.375V54.375C31.875 55.4104 31.0354 56.25 30 56.25ZM9.375 52.5H28.125V26.25H9.375V52.5Z",
    fill: "#2AA7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15H43.125V13.125C43.125 12.0896 42.2854 11.25 41.25 11.25C40.2146 11.25 39.375 12.0896 39.375 13.125V15H37.5C36.4646 15 35.625 15.8396 35.625 16.875C35.625 17.9104 36.4646 18.75 37.5 18.75H39.375V20.625C39.375 21.6604 40.2146 22.5 41.25 22.5C42.2854 22.5 43.125 21.6604 43.125 20.625V18.75H45C46.0354 18.75 46.875 17.9104 46.875 16.875C46.875 15.8396 46.0354 15 45 15Z",
    fill: "#2AA7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37.5C13.9646 37.5 13.125 36.6604 13.125 35.625V31.875C13.125 30.8396 13.9646 30 15 30C16.0354 30 16.875 30.8396 16.875 31.875V35.625C16.875 36.6604 16.0354 37.5 15 37.5Z",
    fill: "#2AA7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 48.75C13.9646 48.75 13.125 47.9104 13.125 46.875V43.125C13.125 42.0896 13.9646 41.25 15 41.25C16.0354 41.25 16.875 42.0896 16.875 43.125V46.875C16.875 47.9104 16.0354 48.75 15 48.75Z",
    fill: "#2AA7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 37.5C21.4646 37.5 20.625 36.6604 20.625 35.625V31.875C20.625 30.8396 21.4646 30 22.5 30C23.5354 30 24.375 30.8396 24.375 31.875V35.625C24.375 36.6604 23.5354 37.5 22.5 37.5Z",
    fill: "#2AA7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 48.75C21.4646 48.75 20.625 47.9104 20.625 46.875V43.125C20.625 42.0896 21.4646 41.25 22.5 41.25C23.5354 41.25 24.375 42.0896 24.375 43.125V46.875C24.375 47.9104 23.5354 48.75 22.5 48.75Z",
    fill: "#2AA7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45 37.5H37.5C36.4646 37.5 35.625 36.6604 35.625 35.625C35.625 34.5896 36.4646 33.75 37.5 33.75H45C46.0354 33.75 46.875 34.5896 46.875 35.625C46.875 36.6604 46.0354 37.5 45 37.5Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.02e694395d5d291ae50ffab1ffc53622.svg";
export { ForwardRef as ReactComponent };